/** Shared Chart.js bar styling — avoids oversized bars on wide screens / few categories. */
export const DASHBOARD_BAR_CHART_OPTIONS = {
    datasets: {
        bar: {
            maxBarThickness: 28,
            categoryPercentage: 0.72,
            barPercentage: 0.82,
        },
    },
};

export function mergeBarChartOptions(extra = {}) {
    return {
        ...DASHBOARD_BAR_CHART_OPTIONS,
        ...extra,
        datasets: {
            ...DASHBOARD_BAR_CHART_OPTIONS.datasets,
            ...(extra.datasets || {}),
            bar: {
                ...DASHBOARD_BAR_CHART_OPTIONS.datasets.bar,
                ...(extra.datasets?.bar || {}),
            },
        },
    };
}
